var map = {
	"./arcadeweb0.jpg": 44,
	"./arcadeweb1.jpg": 45,
	"./arcadeweb2.jpg": 46,
	"./arcadeweb3.jpg": 47,
	"./arcadeweb4.jpg": 48,
	"./autotest0.jpg": 49,
	"./autotest1.jpg": 50,
	"./autotest2.jpg": 51,
	"./autotest3.jpg": 52,
	"./autotest4.jpg": 53,
	"./basketball.jpg": 16,
	"./hoppa0.jpg": 54,
	"./hoppa1.jpg": 55,
	"./hoppa2.jpg": 56,
	"./hoppa3.jpg": 57,
	"./hoppa4.jpg": 58,
	"./mam0.jpg": 59,
	"./mam1.jpg": 60,
	"./mam2.jpg": 61,
	"./mam3.jpg": 62,
	"./monitor0.jpg": 63,
	"./monitor1.jpg": 64,
	"./monitor2.jpg": 65,
	"./monitor3.jpg": 66,
	"./monitor4.jpg": 67,
	"./priceoff0.jpg": 68,
	"./priceoff1.jpg": 69,
	"./priceoff2.jpg": 70,
	"./priceoff3.jpg": 71,
	"./priceoff4.jpg": 72,
	"./singing.jpg": 17,
	"./travel.jpg": 18,
	"./ubike0.jpg": 73,
	"./ubike1.jpg": 74,
	"./ubike2.jpg": 75,
	"./ubike3.jpg": 76,
	"./ubike4.jpg": 77
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43;